import { EntityType } from '@frontend/common';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { ProductCategoryClient } from '@frontend/group/api';
import { CommonMessage } from '@frontend/lang';
import { ProductClient } from '@frontend/product/api';
import { IProduct, ProductType } from '@frontend/product/types';
import { Product } from '@frontend/product/utils';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { PlatformObjectBadge } from '../../../modal/platform-object-badge/platform-object-badge.component';
import OverviewHeader from '../../header/overview-header';
import { useInventory } from './inventory.controller';

export const Inventory = () => {
    const viewProps = useInventory();
    return (
        <div
            key={viewProps.listId}
            className='size-lf-stretch bg-background-default inline-flex w-full flex-col items-start justify-start gap-6'>
            <OverviewHeader
                title={
                    <FormattedMessage
                        id='feature.inventory'
                        defaultMessage='Inventory'
                    />
                }
            />
            <ReactiveObjectList<IProduct>
                fetch={(arg) => ProductClient.fetchProducts({ account_id: viewProps.currentAccount, type: ProductType.EQUIPMENT, ...arg })}
                useStaticListId
                id={viewProps.listId}
                dispatch={viewProps.dispatch}
                columns={{
                    columns: ['sku', 'name', 'category', 'attributes'],
                    headerOverwrite: new Map([['name', CommonMessage.OBJECTS.PRODUCT.DEFAULT]]),
                    customCells: new Map([
                        [
                            'category',
                            (obj) => {
                                const [category, setCategory] = useState<string | undefined>(undefined);
                                useEffect(() => {
                                    ProductCategoryClient.fetchProductCategoryMembers({
                                        entity_id: obj.row.original.id,
                                        account_id: obj.row.original.account_id
                                    }).then((res) => {
                                        if (res.results.length > 0) {
                                            const found = res.results[0];
                                            ProductCategoryClient.fetchProductCategory(found.account_id, found.group_id).then((res) => {
                                                setCategory(res.id);
                                            });
                                        }
                                    });
                                });
                                if (!category) return;
                                return (
                                    <td>
                                        <PlatformObjectBadge
                                            entityType={EntityType.PRODUCT_CATEGORY}
                                            id={category}
                                            display={category}
                                        />
                                    </td>
                                );
                            }
                        ],
                        ['name', (obj) => <td className={defaultCellClassName}>{new Product(obj.row.original).getDefaultName()}</td>],
                        [
                            'attributes',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    <div className='inline-flex gap-2'>
                                        {Object.entries(obj.row.original.attributes || {}).map(([key, value]) => (
                                            <div
                                                key={key}
                                                className='text-foreground-default flex items-center gap-2'>
                                                <span>{key}:</span>
                                                <span>{value}</span>
                                            </div>
                                        ))}
                                    </div>
                                </td>
                            )
                        ]
                    ])
                }}
                type={EntityType.PRODUCT}
            />
        </div>
    );
};
